import { render, staticRenderFns } from "./DataSetComponent.vue?vue&type=template&id=538d5683&scoped=true&"
import script from "./DataSetComponent.vue?vue&type=script&lang=js&"
export * from "./DataSetComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataSetComponent.vue?vue&type=style&index=0&id=538d5683&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d5683",
  null
  
)

export default component.exports